import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { getAllBlogsApi, IMG_URL } from "../helper/api_helper";
import { toast } from "react-toastify";
const BlogDetailsLayer = () => {
  const [searchParams] = useSearchParams();
  const blogId = searchParams.get('id');

  const [currentBlog, setCurrentBlog] = useState(null);


  const [isPageLoading, setIsPageLoading] = useState(false);

  const [blogData, setBlogData] = useState([]);

  const getAllBlogs = async () => {
    try {
      setIsPageLoading(true);
      const response = await getAllBlogsApi();

      setBlogData(response.data);

      if (blogId && response.data) {
        const specificBlog = response.data.find(blog => blog.id === blogId); 
        setCurrentBlog(specificBlog);

      }

    } catch (error) {

      toast.error("Failed to fetch blogs");
      setBlogData([]);
    } finally {
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, [blogId]);

  if (isPageLoading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  // Blog not found
  if (!currentBlog) {
    return <div className="text-center p-5">Blog not found</div>;
  }

  // Format date function
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Calculate days ago
const getDaysAgo = (dateString) => {
  const blogDate = new Date(dateString);
  const today = new Date();
  const diffTime = Math.abs(today - blogDate);
  
  const diffMinutes = Math.floor(diffTime / (1000 * 60));
  const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffMinutes < 1) {
    return 'Just now';
  } else if (diffMinutes < 60) {
    return diffMinutes === 1 ? '1 minute ago' : `${diffMinutes} minutes ago`;
  } else if (diffHours < 24) {
    return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
  } else {
    return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
  }
};
  return (
    <div className='row gy-4'>
      <div className='col-lg-8'>
        <div className='card p-0 radius-12 overflow-hidden'>
          <div className='card-body p-0'>
            <img
              src={`${IMG_URL || 'your-img-base-url'}/${currentBlog.blog_image}`}
              alt={currentBlog.blog_title}
              className='w-100 h-100 object-fit-cover'
            />
            <div className='p-32'>
              <div className='d-flex align-items-center gap-16 justify-content-between flex-wrap mb-24'>
                <div className='d-flex align-items-center gap-8'>
                  <img
                    src='assets/images/user-list/user-list1.png'
                    alt='Author'
                    className='w-48-px h-48-px rounded-circle object-fit-cover'
                  />
                  <div className='d-flex flex-column'>
                    <h6 className='text-lg mb-0'>Admin</h6>
                    <span className='text-sm text-neutral-500'>
                      {getDaysAgo(currentBlog.createdAt)}
                    </span>
                  </div>
                </div>
                <div className='d-flex align-items-center gap-md-3 gap-2 flex-wrap'>
                 
                  <div className='d-flex align-items-center gap-8 text-neutral-500 text-lg fw-medium'>
                    <i className='ri-calendar-2-line' />
                    {formatDate(currentBlog.createdAt)}
                  </div>
                </div>
              </div>

              <h3 className='mb-16'>
                {currentBlog.blog_title}
              </h3>

              {/* Render HTML content safely */}
              <div
                className='text-neutral-500 mb-16'
                dangerouslySetInnerHTML={{ __html: currentBlog.blog_description }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='col-lg-4'>
        <div className='d-flex flex-column gap-24'>
          <div className='card'>
            <div className='card-header border-bottom'>
              <h6 className='text-xl mb-0'>Category</h6>
            </div>
            <div className='card-body p-24'>
              <ul>
                <li className='w-100 d-flex align-items-center justify-content-between flex-wrap gap-8'>
                  <Link
                    to='/blog'
                    className='text-hover-primary-600 transition-2'
                  >
                    {currentBlog.blog_category?.category_name || 'Uncategorized'}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className='card'>
            <div className='card-header border-bottom'>
              <h6 className='text-xl mb-0'>Tags</h6>
            </div>
            <div className='card-body p-24'>
              <div className='d-flex align-items-center flex-wrap gap-8'>
                {/* You'll need to fetch tag names based on blog_tag_id array */}
                {currentBlog.tags && currentBlog.tags.map((tagName, index) => (
                  <Link
                    key={tagName?.id}
                    to='/blog'
                    className='btn btn-sm btn-primary-600 bg-primary-50 bg-hover-primary-600 text-primary-600 border-0 d-inline-flex align-items-center gap-1 text-sm px-16 py-6'
                  >
                  {tagName?.tag_name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsLayer;
